import { SvgComponentProps } from "@/src/types/SVGPropType";
import * as React from "react";
const Hobby7SVG: React.FC<SvgComponentProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    {...props}
  >
    <path
      fill="#EDEDED"
      fillRule="evenodd"
      d="M2.5 4.06A3.25 3.25 0 0 1 5.75.81h.5A3.25 3.25 0 0 1 9.5 4.06v.5a3.25 3.25 0 0 1-3.25 3.25h-.5A3.25 3.25 0 0 1 2.5 4.56v-.5Zm3.25-1.75A1.75 1.75 0 0 0 4 4.06v.5c0 .967.784 1.75 1.75 1.75h.5A1.75 1.75 0 0 0 8 4.56v-.5a1.75 1.75 0 0 0-1.75-1.75h-.5Zm-4.25 13v-1.329a4.844 4.844 0 0 1 4.33-2.67h.34a4.844 4.844 0 0 1 4.33 2.67v1.33h-9Zm4.33-5.5a6.344 6.344 0 0 0-5.761 3.686l-.069.15v3.164h12v-3.164l-.069-.15a6.344 6.344 0 0 0-5.76-3.685h-.342Zm10.101 3.686a6.34 6.34 0 0 0-2.587-2.835l-.75 1.299A4.84 4.84 0 0 1 14.5 13.98v1.33h-1v1.5H16v-3.165l-.069-.15ZM11.25.811h-.75v1.5h.75c.966 0 1.75.783 1.75 1.75v.5a1.75 1.75 0 0 1-1.75 1.75h-.75v1.5h.75a3.25 3.25 0 0 0 3.25-3.25v-.5A3.25 3.25 0 0 0 11.25.81Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Hobby7SVG;
